<template>
  <div class="feature-toggle">
    <div v-if="label.length" class="header header-top" @click="toggleExpand">
      <div class="left">
        <div class="col-6" style="width: 100%;">
          <div class="d-flex">
            <span class="title">{{ label }}</span>
            <Tooltip
              :text="label == 'Executable Control' ? tooltips.process.applicationExecutionControl : tooltips.process.moduleControl">
              <i class="ag-icon ag-icon_table_info small info-icon"></i>
            </Tooltip>
          </div>
          <span style="font-size: 0.7rem; color: #000;">Allow to run <span style="color: #ddd;"> | </span> <span
              :class="allowToRunValue ? 'onText' : 'offText'">{{ allowToRunValue ? 'On' : 'Off' }}</span></span>
        </div>
        <div class="col-6 switch-container ">
          <label class="switch" @click.stop>
            <input type="checkbox" :checked="modelValue" @change="$emit('update:modelValue', $event.target.checked)" />
            <span class="slider" />
          </label>
          <span class="switch-status">{{ modelValue ? 'On' : 'Off' }}</span>
        </div>

      </div>

      <div class="right">

        <i class="pi" :class="isExpanded ? 'pi-chevron-up' : 'pi-chevron-down'" />
      </div>
    </div>

    <div v-if="isExpanded || type == 'codeLoad'" class="accordion-content" :class="{ 'disabled-section': !modelValue }">
      <div v-if="isVisible('discoveryModeCheck')" class="header ">
        <div class="d-flex header-discovery-mode">
          <div class="col-12 d-flex" style="width: 100%; padding-left: 0px;">

            <span style="font-size:0.758rem; color: #000;"> <i class="pi pi-search small"
                style="color: gray; margin-right: 5px;"></i>Process Start Discovery Mode</span>
            <Tooltip :text="tooltips.process.startDiscoveryMode">
              <i class="ag-icon ag-icon_table_info small info-icon"></i>
            </Tooltip>
            <label class="switch" style="margin-left: 5px;" @click.stop>
              <input type="checkbox" v-model="props.form.discoveryMode" :disabled="!modelValue" />
              <span class="slider" />
            </label>
            <span class="switch-status">{{ props.form.discoveryMode ? 'On' : 'Off' }}</span>
          </div>

        </div>
      </div>
      <div class="custom-tabs">
        <div class="tab-button" :class="{ active: activeTab === 'conditions' }" @click="activeTab = 'conditions'">
          Conditions
        </div>
        <div class="tab-button" :class="{ active: activeTab === 'actions' }" @click="activeTab = 'actions'">
          Security Actions
        </div>
      </div>
      <div class="tab-content">
        <!-- Conditions Tab -->
        <div v-if="activeTab === 'conditions'">
          <div class="form-grid">
            <div v-if="isVisible('publisher')" class="form-row">
              <div class="col-6 d-flex">
                <Checkbox v-model="isSigned" :binary="true" />
                <label class="input-label">Is signed by a trusted publisher</label>
                <Tooltip :text="tooltips.process.publisher">
                  <i class="ag-icon ag-icon_table_info small info-icon"></i>
                </Tooltip>
              </div>
              <div class="col-6">
                <Dropdown v-model="publisherProxy" :options="publisherListOptions" optionLabel="label"
                  optionValue="value" class="form-dropdown-input" :disabled="!isSigned" placeholder="None" />
              </div>

            </div>
            <div v-if="isVisible('hashCheck')" class="form-row">
              <div class="col-6 d-flex">
                <Checkbox v-model="checkHash" :binary="true" />
                <label class="input-label">Verify Hash</label>
                <Tooltip :text="tooltips.process.hasMustMatch">
                  <i class="ag-icon ag-icon_table_info small info-icon"></i>
                </Tooltip>
              </div>
              <div class="col-6">
                <InputText v-model="hashValue" placeholder="Enter hash" :disabled="!checkHash" class="form-input" />
                <small v-if="hashValue && hashAlgorithmValue === null" class="p-error error-text">SHA-256 hash must be exactly 64 hexadecimal characters (0–9, A–F/a–f) and contain no spaces or prefixes.</small>
              </div>

            </div>
            <div v-if="isVisible('algorithm')" class="form-row">
              <div class="col-6 d-flex" style="padding-left: 40px;">
                <i class="ag-icon ag-icon_algorithm"></i>
                <label class="input-label">Algorithm</label>
              </div>
              <div class="col-6">
                <Dropdown v-model="hashAlgorithmValue" :options="hashAlgorithmOptions" optionLabel="label"
                  optionValue="value" class="form-dropdown-input" :disabled="true" placeholder="Enter hash algorithm" />
              </div>

            </div>
            <div v-if="isVisible('commandLineCheck')" class="form-row">
              <div class="col-6 d-flex">
                <Checkbox v-model="checkCommandLine" :binary="true" disabled="true" />
                <label class="input-label">Command Line</label>
                <Tooltip :text="tooltips.process.commandLine">
                  <i class="ag-icon ag-icon_table_info small info-icon"></i>
                </Tooltip>
              </div>
              <div class="col-6">
                <InputText v-model="commandLineValue" placeholder="Enter command line" :disabled="!checkCommandLine"
                  class="form-input" />
              </div>

            </div>
            <div v-if="isVisible('zoneCheck')" class="form-row">
              <div class="col-6 d-flex ">
                <Checkbox v-model="checkZone" :binary="true" />
                <label class="input-label">Zone Identifier</label>
                <Tooltip :text="tooltips.process.zoneIdentifier">
                  <i class="ag-icon ag-icon_table_info small info-icon"></i>
                </Tooltip>
              </div>

              <div class="col-6">
                <Dropdown v-model="zoneValue" :options="zoneIdentifierOptions" optionLabel="label" optionValue="value"
                  :disabled="!checkZone" class="form-dropdown-input" placeholder="Local Machine" />
              </div>

            </div>
          </div>
        </div>

        <!-- Security Actions Tab -->
        <div v-else>
          <div class="form-grid">
            <div v-if="isVisible('allowToRun')" class="form-row">
              <div class="col-5 d-flex">
                <i class="ag-icon ag-icon_security"></i>
                <label class="input-label">Allow to run</label>
                <Tooltip :text="tooltips.process.allowToRun">
                  <i class="ag-icon ag-icon_table_info small info-icon"></i>
                </Tooltip>
              </div>
              <div class="col-7">
                <label class="switch">
                  <input type="checkbox" v-model="allowToRunValue" :disabled="isPowerApps" />
                  <span class="slider" />
                </label>
                <span class="switch-status">{{ allowToRunValue ? 'On' : 'Off' }}</span>
              </div>


            </div>
            <div v-if="isVisible('seamlessInstaller')" class="form-row">
              <div class="col-5 d-flex">
                <i class="ag-icon ag-icon_lock"></i>
                <label class="input-label">Seamless Installer</label>
                <Tooltip :text="tooltips.process.seamlessInstaller">
                  <i class="ag-icon ag-icon_table_info small info-icon"></i>
                </Tooltip>
              </div>
              <div class="col-7">
                <label class="switch">
                  <input type="checkbox" v-model="seamlessInstallerValue"
                    :disabled="!isPowerApps && !allowToRunValue" />
                  <span class="slider" />
                </label>
                <span class="switch-status">{{ seamlessInstallerValue ? 'On' : 'Off' }}</span>
              </div>

            </div>
            <div v-if="isVisible('containment')" class="form-row">
              <div class="col-5 d-flex">
                <i class="ag-icon ag-icon_placeholder"></i>
                <label class="input-label">AppGroups</label>
                <Tooltip :text="tooltips.process.containment">
                  <i class="ag-icon ag-icon_table_info small info-icon"></i>
                </Tooltip>
              </div>
              <div class="col-7">
                <InputText v-model="appGroupInfo.name" class="form-input" disabled="true" />
              </div>

            </div>
            <div v-if="isVisible('childProcess')" class="form-row">
              <div class="col-5 d-flex">
                <i class="ag-icon ag-icon_placeholder"></i>
                <label class="input-label">Child Process</label>
                <Tooltip :text="tooltips.process.childProcess">
                  <i class="ag-icon ag-icon_table_info small info-icon"></i>
                </Tooltip>
              </div>
              <div class="col-7">
                <Dropdown v-model="childProcessValue" :options="childProcessOptions" optionLabel="label"
                  optionValue="value" class="form-dropdown-input"
                  :disabled="(readOnlySecurityActions || readOnlyModuleActions) && (!allowToRunValue || readOnlyPowerApps)" />
              </div>

            </div>
            <div v-if="isVisible('codeLoad')" class="form-row">
              <div class="col-5 d-flex">
                <i class="ag-icon ag-icon_placeholder"></i>
                <label class="input-label">Code Load</label>
                <Tooltip :text="tooltips.process.codeLoad">
                  <i class="ag-icon ag-icon_table_info small info-icon"></i>
                </Tooltip>
              </div>
              <div class="col-7">
                <Dropdown v-model="codeLoadValue" :options="codeLoadOptions" optionLabel="label" optionValue="value"
                  class="form-dropdown-input"
                  :disabled="(readOnlySecurityActions || readOnlyModuleActions) && (!allowToRunValue)" />
              </div>
            </div>
            <PanelCheckBoxGroup v-if="isVisible('aecMemorySecurity')" v-model="props.form.aecSecurityMemory"
              label="Memory Security" :options="memoriesOptions" showIcon="true" :formType="formType"
              :disabled="(readOnlySecurityActions && !allowToRunValue) || isPowerApps"
              :tooltip="tooltips.process.memorySecurity" />
            <PanelCheckBoxGroup v-if="isVisible('moduleSecurityMemory')" v-model="props.form.moduleSecurityMemory"
              label="Memory Security" :options="memoriesOptions" showIcon="true" :formType="formType"
              :disabled="(readOnlySecurityActions && !allowToRunValue) || isPowerApps"
              :tooltip="tooltips.process.memorySecurity" />
            <PanelCheckBoxGroup v-if="isVisible('inheritance')" v-model="props.form.aecSecurityInheritance"
              label="Inheritance" :options="inheritanceOptions" showIcon="true" :formType="formType"
              :disabled="(readOnlySecurityActions && !allowToRunValue)" :disabledOptions="inheritanceDisabledOptions"
              :tooltip="tooltips.process.inheritance" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineEmits, defineProps, ref, computed, onMounted, watch } from 'vue'
import Checkbox from 'primevue/checkbox'
import Dropdown from 'primevue/dropdown'
import InputText from 'primevue/inputtext'
import Multiselect from "@vueform/multiselect";
import PanelCheckBoxGroup from './panelCheckBoxGroup.vue';
import { useStore } from "@/store";
import { AppGroupTypes } from '@/helpers/enums/AppGroupTypes';
import tooltips from '@/assets/tooltips/en.json'
import Tooltip from './tooltip.vue'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: true
  },
  label: String,
  type: {
    type: String,
    default: 'application'
  },
  form: {
    type: Object,
    required: true
  },
  formType: {
    type: String,
  }
})
const store = useStore();
const emit = defineEmits(['update:modelValue', 'update:form'])
const isExpanded = ref(false)
const activeTab = ref('conditions')
const checkZone = ref(false);
const checkHash = ref(false);
const checkCommandLine = ref(false)
const zoneIdentifierOptions = computed(() => store.state.general.enums['ZoneIdentifier'] || [])
// const hashAlgorithmOptions = computed(() => store.state.general.enums['HashAlgorithmTypes'] || [])
const hashAlgorithmOptions = computed(() => {
  const original = store.state.general.enums['HashAlgorithmTypes'] || [];
  return [{ label: "", value: null }, ...original];
});
const memoriesOptions = computed(() => store.state.general.enums['AppGroupProcessMemorySecurity'] || [])
const inheritanceOptions = computed(() => store.state.general.enums['AecSecurityInheritance '] || [])
const appGroupInfo = computed(() => store.state.general.appGroupInfo)
const publisherListOptions = computed(() => {
  const original = store.state.general.publisherList || [];
  return [{ label: "None", value: null }, { label: "Any", value: -1 }, ...original];
});
const codeLoadOptions = computed(() => {
  return store.state.general.enums['CodeLoadSecurity'] || [];
});

const childProcessOptions = computed(() => {
  return store.state.general.enums['ChildProcessTypes'] || [];
});

const isSigned = ref(false);

const visibleFields = {
  publisher: ['application', 'module', 'codeLoad'],
  hashCheck: ['application', 'module'],
  algorithm: ['application', 'module'],
  commandLineCheck: ['application'],
  zoneCheck: ['application', 'module', 'codeLoad'],
  allowToRun: ['application', 'module', 'codeLoad'],
  seamlessInstaller: ['application', 'module'],
  containment: ['application', 'module'],
  childProcess: ['application', 'module'],
  memorySecurity: ['application', 'module'],
  inheritance: ['application'],
  discoveryModeCheck: ['application'],
  aecMemorySecurity: ['application'],
  moduleSecurityMemory: ['module'],
  codeLoad: ['application']
}

function isVisible(field) {
  return visibleFields[field]?.includes(props.type)
}

const zoneIdentifierKey = computed(() => {
  if (props.type === 'application') return 'aecConditionZoneIdentifier';
  if (props.type === 'module') return 'moduleConditionZoneIdentifier';
  return 'zoneIdentifier'; // default for codeLoad
});

const zoneValue = computed({
  get: () => props.form[zoneIdentifierKey.value],
  set: (val) => {
    if (!props.form[zoneIdentifierKey.value]) {
      props.form[zoneIdentifierKey.value] = null;
    }
    props.form[zoneIdentifierKey.value] = val;
  }
});

const publisherKey = computed(() => {
  if (props.type === 'application') return 'aecPublisherId';
  if (props.type === 'module') return 'modulePublisherId';
  return 'publisherId'; // default for codeLoad
});

const publisherAnyKey = computed(() => {
  if (props.type === "application") return "isAecPublisherIdAny";
  if (props.type === "module") return "isModulePublisherIdAny";
  return "isPublisherIdAny";
});

const publisherProxy = computed({
  get: () => {
    return props.form[publisherAnyKey.value] ? -1 : props.form[publisherKey.value];
  },
  set: (val) => {
    if (val === -1) {
      props.form[publisherAnyKey.value] = true;
      props.form[publisherKey.value] = -1;
    } else {
      props.form[publisherAnyKey.value] = false;
      props.form[publisherKey.value] = val;
    }
  },
});

const hashKey = computed(() => {
  if (props.type === 'application') return 'aecConditionHash';
  if (props.type === 'module') return 'moduleConditionHash';
  return ''
});

const hashValue = computed({
  get: () => props.form[hashKey.value],
  set: (val) => {
    if (!props.form[hashKey.value]) {
      props.form[hashKey.value] = null;
    }
    props.form[hashKey.value] = val;
  }
});
const commandLineKey = computed(() => {
  if (props.type === 'application') return 'aecConditionCommandLine';
  return ''
});

const commandLineValue = computed({
  get: () => props.form[commandLineKey.value],
  set: (val) => {
    if (!props.form[commandLineKey.value]) {
      props.form[commandLineKey.value] = null;
    }
    props.form[commandLineKey.value] = val;
  }
});

const hashAlgorithmKey = computed(() => {
  if (props.type === 'application') return 'aecConditionHashAlgorithm';
  if (props.type === 'module') return 'moduleConditionHashAlgorithm';
  return '';
});

const hashAlgorithmValue = computed({
  get: () => props.form[hashAlgorithmKey.value],
  set: (val) => {
    if (!props.form[hashAlgorithmKey.value]) {
      props.form[hashAlgorithmKey.value] = null;
    }
    props.form[hashAlgorithmKey.value] = val;
  }
});
const allowToRunKey = computed(() => {
  if (props.type === 'application') return 'aecSecurityAllowRun';
  if (props.type === 'module') return 'moduleSecurityAllowRun';
  return 'allowToRun'; // default for codeLoad
});
const allowToRunValue = computed({
  get: () => props.form[allowToRunKey.value],
  set: (val) => {
    if (!props.form[allowToRunKey.value]) {
      props.form[allowToRunKey.value] = null;
    }
    props.form[allowToRunKey.value] = val;
  }
});

const seamlessInstallerKey = computed(() => {
  if (props.type === 'application') return 'aecSecuritySeamlessInstaller';
  if (props.type === 'module') return 'moduleSecuritySeamlessInstaller';
  return '';
});
const seamlessInstallerValue = computed({
  get: () => props.form[seamlessInstallerKey.value],
  set: (val) => {
    if (!props.form[seamlessInstallerKey.value]) {
      props.form[seamlessInstallerKey.value] = null;
    }
    props.form[seamlessInstallerKey.value] = val;
  }
});

const childProcessKey = computed(() => {
  if (props.type === 'application') return 'aecSecurityChildProcess';
  if (props.type === 'module') return 'moduleSecurityChildProcess';
  return '';
});
const childProcessValue = computed({
  get: () => props.form[childProcessKey.value],
  set: (val) => {
    if (!props.form[childProcessKey.value]) {
      props.form[childProcessKey.value] = null;
    }
    props.form[childProcessKey.value] = val;
  }
});
const codeLoadKey = computed(() => {
  if (props.type === 'application') return 'aecCodeLoadSecurity';
  if (props.type === 'module') return 'moduleCodeLoadSecurity';
  return '';
})
const codeLoadValue = computed({
  get: () => props.form[codeLoadKey.value],
  set: (val) => {
    if (!props.form[codeLoadKey.value]) {
      props.form[codeLoadKey.value] = 0;
    }
    props.form[codeLoadKey.value] = val;
  }
})

watch(
  () => props.modelValue,
  (newVal) => {
    if (!newVal) {
      props.form.discoveryMode = false
      checkZone.value = false;
      checkHash.value = false;
      checkCommandLine.value = false;
      isSigned.value = false;

      const seamlessKey = seamlessInstallerKey.value
      props.form[seamlessKey] = false

      props.form.aecSecurityMemory = 0
      props.form.moduleSecurityMemory = 0
      props.form.aecSecurityInheritance = 0

      allowToRunValue.value = false;

      const cKey = codeLoadKey.value;
      if (cKey) {
        props.form[cKey] = 0;
      }
    } else {

      const cKey = codeLoadKey.value;
      if (cKey) {
        props.form[cKey] = isPowerApps.value ? 2 : 1;
      }
      allowToRunValue.value = true;
      //Default options for Power Apps
      if (isPowerApps.value && props.formType === 'process') {
        const childKey = childProcessKey.value;
        if (childKey) {
          props.form[childKey] = 2;
        }

        const memProt = memoriesOptions.value.find(o => String(o.label).toLowerCase() === 'memory protection');
        const memWhite = memoriesOptions.value.find(o => String(o.label).toLowerCase() === 'memory whitelisting');
        const memTotal = Number(memProt?.value || 0) + Number(memWhite?.value || 0);
        props.form.aecSecurityMemory = memTotal;
        props.form.moduleSecurityMemory = memTotal;

        if (props.type === 'application') {
          const inhSum = (inheritanceOptions.value || []).reduce((acc, o) => acc + Number(o.value || 0), 0);
          props.form.aecSecurityInheritance = inhSum;
        }
      } else if (!isPowerApps.value && props.formType === 'process') {
        //Default options for other Apps
        const childKey = childProcessKey.value;
        if (childKey) {
          const defaultChild = appGroupInfo.value?.childProcess ? 2 : 4;
          props.form[childKey] = defaultChild;
        }
        const defaultMemory = (appGroupInfo.value && appGroupInfo.value.memorySecurity != null)
          ? Number(appGroupInfo.value.memorySecurity)
          : 0;
        if (props.type === 'application') {
          props.form.aecSecurityMemory = defaultMemory;
          const defaultInheritance = appGroupInfo.value && appGroupInfo.value.inheritance != null ? Number(appGroupInfo.value.inheritance) : 0;
          props.form.aecSecurityInheritance = defaultInheritance;
        } else if (props.type === 'module') {
          props.form.moduleSecurityMemory = defaultMemory;
        }
      }
    }
  }
)

watch(isPowerApps, (newVal) => {
  if (newVal) {
    allowToRunValue.value = !!props.modelValue;
  }
})

watch(() => isSigned.value, (newVal) => {
  if (!newVal) {
    props.form[publisherKey.value] = null;
    props.form[publisherAnyKey.value] = false;
  } else {
    if (!props.form[publisherKey.value] && !props.form[publisherAnyKey.value]) {
      props.form[publisherAnyKey.value] = true;
      props.form[publisherKey.value] = -1;
    }
  }
})

watch(checkHash, (newVal) => {
  if (!newVal) {
    props.form[hashKey.value] = null;
    props.form[hashAlgorithmKey.value] = null;
  }
});

watch(checkCommandLine, (newVal) => {
  if (!newVal) {
    props.form[commandLineKey.value] = null;
  }
});

watch(checkZone, (newVal) => {
  if (!newVal) {
    props.form[zoneIdentifierKey.value] = 0;
  }
});

watch(() => allowToRunValue.value, (newVal) => {
  if (!newVal) {
    const seamlessKey = seamlessInstallerKey.value;
    const childKey = childProcessKey.value;
    if (seamlessKey) props.form[seamlessKey] = false;
    if (childKey) props.form[childKey] = 0;
    if (props.type === 'application') {
      props.form.aecSecurityMemory = 0;
      props.form.aecSecurityInheritance = 0;
    }
    if (props.type === 'module') {
      props.form.moduleSecurityMemory = 0;
    }
  }
})

onMounted(() => {
  if (props.form.id) {
    if (props.form[publisherKey.value] || props.form[publisherAnyKey.value]) {
      isSigned.value = true;
    }

    if (props.form[hashKey.value]) {
      checkHash.value = true;
    }

    if (props.form[commandLineKey.value]) {
      checkCommandLine.value = true;
    }

    if (props.form[zoneIdentifierKey.value]) {
      checkZone.value = true;
      props.form[zoneIdentifierKey.value] = props.form[zoneIdentifierKey.value]
    }

  }

  if (!props.form.id) {
    const defaultMemory = appGroupInfo.value && appGroupInfo.value.memorySecurity != null ? appGroupInfo.value.memorySecurity : 0;
    const defaultInheritance = appGroupInfo.value && appGroupInfo.value.inheritance != null ? appGroupInfo.value.inheritance : 0;

    if (props.type === 'application') {
      if (props.form.aecSecurityMemory == null) {
        props.form.aecSecurityMemory = defaultMemory;
      }
      if (props.form.aecSecurityInheritance == null) {
        props.form.aecSecurityInheritance = defaultInheritance;
      }
    }

    if (props.type === 'module') {
      if (props.form.moduleSecurityMemory == null) {
        props.form.moduleSecurityMemory = defaultMemory;
      }
      if (isPowerApps.value) {
        props.form[childProcessKey.value] = 2;
      }
    }
  }

});

watch(() => hashValue.value, (newVal) => {
  const detected = detectHashAlgorithm(newVal);
  const match = hashAlgorithmOptions.value.find(opt => opt.label === detected);
  hashAlgorithmValue.value = match ? match.value : null;
});

watch(childProcessOptions, (newVal) => {
  if (
    (props.form[childProcessKey.value] === null || props.form[childProcessKey.value] === undefined) &&
    newVal.length > 0
  ) {
    const noneOption = newVal.find(o => o.label === "None");
    if (noneOption) {
      props.form[childProcessKey.value] = noneOption.value;
    }
  }
}, { immediate: true });

watch(codeLoadOptions, (newVal) => {
  if (
    (props.form[codeLoadKey.value] === null || props.form[codeLoadKey.value] === undefined) &&
    newVal.length > 0
  ) {
    const noneOption = newVal.find(o => o.label === "None");
    if (noneOption) {
      props.form[codeLoadKey.value] = noneOption.value;
    }
  }
}, { immediate: true });


function detectHashAlgorithm(hash) {
  const hexRegex = /^[a-fA-F0-9]+$/;

  if (!hexRegex.test(hash)) return null;

  switch (hash.length) {
    case 32:
      return 'MD5';
    case 40:
      return 'SHA-1';
    case 64:
      return 'SHA-2';
    default:
      return null;
  }
}

function toggleExpand() {
  isExpanded.value = !isExpanded.value
}

const isPowerApps = computed(() => (Number(appGroupInfo.value?.appGroupType)) === AppGroupTypes.PowerApps);

const readOnlySecurityActions = computed(() => props.formType === 'process' && props.modelValue === true);

const readOnlyPowerApps = computed(() => isPowerApps.value && props.formType === 'process');

const readOnlyModuleActions = computed(() => props.formType === 'process' && props.type === 'module' && props.modelValue === true);

watch(isPowerApps, (newVal) => {
  if (newVal && props.formType === 'process') {
    const memProt = memoriesOptions.value.find(o => o.label === 'Memory Protection');
    const memWhite = memoriesOptions.value.find(o => o.label === 'Memory Whitelisting');
    const total = (memProt?.value || 0) + (memWhite?.value || 0);
    props.form.aecSecurityMemory = total;
    props.form.moduleSecurityMemory = total;
  }
}, { immediate: true });

watch([inheritanceOptions, isPowerApps, () => props.formType, () => props.type], () => {
  if (props.formType === 'process' && props.type === 'application') {
    if (!props.form.id && (props.form.aecSecurityInheritance === null || props.form.aecSecurityInheritance === undefined)) {
      if (isPowerApps.value) {
        const inhSum = (inheritanceOptions.value || []).reduce((acc, o) => acc + Number(o.value || 0), 0);
        props.form.aecSecurityInheritance = inhSum;
      } else {
        const defaultInheritance = appGroupInfo.value && appGroupInfo.value.inheritance != null ? Number(appGroupInfo.value.inheritance) : 0;
        props.form.aecSecurityInheritance = defaultInheritance;
      }
    }
  }
}, { immediate: true });

//Inheritance configuration Group Validation
const inheritanceBits = computed(() => {
  const opts = inheritanceOptions.value || [];
  const enforce = opts.find(o => /enforce\s*inheritance/i.test(String(o.label)));
  const childAlways = opts.find(o => /child\s*process.*always\s*inherit/i.test(String(o.label)));
  return {
    enforce: Number(enforce?.value || 0),
    childAlways: Number(childAlways?.value || 0),
  };
});

watch([
  () => props.form.aecSecurityInheritance,
  inheritanceOptions
], ([newMask], [oldMask]) => {
  const { enforce, childAlways } = inheritanceBits.value;
  if (!enforce || !childAlways) return;
  const prevHasEnforce = (Number(oldMask) & enforce) === enforce;
  const prevHasChild = (Number(oldMask) & childAlways) === childAlways;
  const hasEnforce = (Number(newMask) & enforce) === enforce;
  const hasChild = (Number(newMask) & childAlways) === childAlways;
  if (isPowerApps.value) {
    if (!prevHasChild && !hasChild && hasEnforce) {
      props.form.aecSecurityInheritance = Number(newMask) | childAlways;
      return;
    }

    if (prevHasEnforce && !hasEnforce && hasChild) {
      props.form.aecSecurityInheritance = Number(newMask) & ~childAlways;
      return;
    }
  } else {
    if (!prevHasChild && hasChild && !hasEnforce && !isPowerApps.value) {
      props.form.aecSecurityInheritance = Number(newMask) | enforce;
      return;
    }

    if (prevHasEnforce && !hasEnforce && hasChild && !isPowerApps.value) {
      props.form.aecSecurityInheritance = Number(newMask) & ~childAlways;
      return;
    }
  }

});
const inheritanceDisabledOptions = computed(() => {
  if (isPowerApps.value && props.type === 'application') {
    const opts = inheritanceOptions.value || [];
    return opts.slice(1).map(o => o.value);
  }
  return [];
});
</script>

<style scoped>
.accordion-content {
  background-color: #F5F5F5;
  padding: 30px 20px 14px 14px;
}

.disabled-section {
  pointer-events: none;
  opacity: 0.6;
}

.header {
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  cursor: pointer;
}

.header-top {
  padding: 14px 35px 14px 8px;
  border-top: 1px solid #ddd;
}

.header-discovery-mode {
  border: 1px solid #ddd;
  margin: 0 16px 14px 16px;
  padding: 8px 16px 8px 16px;
}

.left {
  display: flex;
  grid-template-columns: auto auto 1fr auto auto;
  align-items: center;
  /* column-gap: 8px; */
}

.spacer {
  width: 30%;
}

.title {
  font-weight: bold;
  color: #164B6C;
}

.info-icon {
  color: #9cb3c9;

}

.right {
  display: flex;
  align-items: center;
  gap: 10px;
}

.switch {
  position: relative;
  display: inline-block;
  width: 28px;
  height: 16px;
  margin-bottom: 0;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
  /* margin-left: 8px; */
}

.switch-status {
  margin-left: 10px;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 34px;
}

.slider::before {
  content: "";
  position: absolute;
  height: 12px;
  width: 12px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

input:checked+.slider {
  background-color: #2f7ecf;
}

input:checked+.slider::before {
  transform: translateX(12px);
}

input:disabled+.slider {
  background-color: #ccc;
  cursor: default;
}

input:checked:disabled+.slider {
  background-color: #2f7ecf;
  opacity: 0.5;
}

.custom-tabs {
  display: flex;
  padding: 16px 16px;
}

.tab-button {
  flex: 1;
  text-align: center;
  padding: 12px 0;
  color: #000;
  cursor: pointer;
  border: 1px solid #ddd;
}

.tab-button.active {
  background-color: transparent;
  border: 2px solid #155ca8;
  font-weight: bold;
  color: #155ca8;
}

.tab-content {
  padding: 1rem;
  border-top: none;
}

.form-grid {
  display: flex;
  flex-direction: column;
  /* gap: 1rem; */
}

.form-row {
  display: flex;
  align-items: center;
}

.group-box {
  flex-direction: column;
  align-items: flex-start;
}

.checkbox-group {
  display: flex;
  flex-direction: column;
  margin-left: 2rem;
}

::v-deep(.p-checkbox .p-checkbox-box) {
  background: transparent !important;
}

::v-deep(.p-checkbox.p-highlight .p-checkbox-box) {
  border-color: #3B82F6 !important;
  background: #3B82F6 !important;
}

.boxed-group {
  width: 100%;
  border: 1px solid #dcdcdc;
  border-radius: 6px;
  padding: 12px;
  margin-right: 10px;

}

.input-label {
  margin-left: 10px;
  font-size: 0.758rem !important;
}

.form-input {
  width: 100%;
  font-size: 0.875rem;
  padding: 0.25rem 0.5rem;
  background: transparent !important;
}

.form-dropdown-input {
  font-size: 0.8rem !important;
  padding: 0.25rem 0.5rem;
  height: 30px;
  align-items: center;
  width: 100%;
  background: transparent !important;
}

.feature-toggle i {
  color: #4c8dbb;
  font-weight: bold;
}

::v-deep(.p-multiselect-panel) {
  max-height: 300px !important;
  overflow-y: auto !important;
  z-index: 9999 !important;
}

.switch-container {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 120px;
  justify-self: anchor-center;
  padding-left: 0;
}

.form-row .col-6.d-flex,
.form-row .col-5.d-flex {
  align-items: center;
  gap: 8px;
}

.form-row .input-label {
  display: inline-flex;
  align-items: center;
  line-height: 1;
  margin: 0;
}

::v-deep(.p-checkbox) {
  display: inline-flex;
  align-items: center;
}

::v-deep(.p-inputtext) {
  padding: 0.25rem 0.5rem !important;
  font-size: 0.8rem !important;
}

.onText {
  font-weight: bold;
  color: #3C73AA;
}

.offText {
  font-weight: bold;
  color: #5d5f62;
}

.error-text {
  line-height: 1 !important;
  display: inline-block;
  margin-top: 5px;
}
</style>
